import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import InputForm from '../../../../../components/form/InputForm';
import SelectForm from '../../../../../components/form/SelectForm';
import { MAXIMUM_NUMBER_OF_INVOICE_NUMBER } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_DELIVERY_TYPE,
  ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST,
} from '../../../../../constants/service/app/orderConstants';
import { numberKeyPress, setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REX_EXCEPT_NUMBER } from '../../../../../lib/rex';
import './EditExchangeDeliveryInfoModal.scss';

const EditExchangeDeliveryInfoModal = (props) => {
  const {
    form,
    isOpen,
    data,
    closeModal,
    setData,
    onSubmit,
    exchangeDeliveryType,
    exchangeDeliveryAgentId,
    exchangeInvoiceNumber,
  } = props;
  const { deliveryAgentList, orderItemList } = data;

  return (
    <Modal
      title="재배송 송장 수정"
      isOpen={isOpen}
      width={660}
      height={600}
      isFooter={true}
      okText="재배송 송장 수정"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="edit-exchange-delivery-info-modal-wrap">
        <div className="edit-exchange-delivery-info">
          <div>* 함께 처리 가능한 상품 주문건이 모두 노출됩니다.</div>
        </div>

        <div className="title">교환 정보 확인</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            {orderItemList.map((item, index) => (
              <tr key={index}>
                <td className="tc">{item.orderItemId}</td>
                <td className="tc">{item.productName}</td>
                <td className="tc">{setNumberWithComma(item.productPrice, '원')}</td>
              </tr>
            ))}
          </tbody>
        </InfoTable>

        <InfoTable className="edit-exchange-delivery-info-table">
          <tbody>
            <tr>
              <td className="tc label">배송방법</td>
              <td className="tl" colSpan={3}>
                <SelectForm
                  form={form}
                  name="exchangeDeliveryType"
                  rules={[formRequiredRules(true, null, false)]}
                  list={ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST}
                  initialValue={exchangeDeliveryType}
                  size="default"
                  isTable={true}
                  onChange={(value) =>
                    setData({
                      name: 'exchangeDeliveryType',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            {exchangeDeliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? (
              <Fragment>
                <tr>
                  <td className="tc label">택배사</td>
                  <td className="tl" colSpan={3}>
                    <SelectForm
                      form={form}
                      name="exchangeDeliveryAgentId"
                      rules={[formRequiredRules(true, null, false)]}
                      list={deliveryAgentList}
                      initialValue={exchangeDeliveryAgentId}
                      size="default"
                      isTable={true}
                      onChange={(value) =>
                        setData({
                          name: 'exchangeDeliveryAgentId',
                          value,
                        })
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td className="tc label">송장번호</td>
                  <td className="tl" colSpan={3}>
                    <InputForm
                      form={form}
                      name="exchangeInvoiceNumber"
                      rules={[formRequiredRules(true, null)]}
                      getValueFromEvent={(value) => value.replace(REX_EXCEPT_NUMBER, '')}
                      onKeyUp={(e) => numberKeyPress(e)}
                      initialValue={exchangeInvoiceNumber}
                      maxLength={MAXIMUM_NUMBER_OF_INVOICE_NUMBER}
                      onChange={(value) =>
                        setData({
                          name: 'exchangeInvoiceNumber',
                          value: value.replace(REX_EXCEPT_NUMBER, ''),
                        })
                      }
                    />
                  </td>
                </tr>
              </Fragment>
            ) : null}
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default EditExchangeDeliveryInfoModal;
